import { render, staticRenderFns } from "./elec_generate.vue?vue&type=template&id=475b274e&"
import script from "./elec_generate.vue?vue&type=script&lang=js&"
export * from "./elec_generate.vue?vue&type=script&lang=js&"
import style0 from "./elec_generate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports